Librarian.DropZone = new Class({
    Implements: [Options],
    Binds: ["onDragOver", "onDragLeave", "onDrop"],
    options: {
        target: null,
        targetClass: "dropzone",
        dragClass: "dropzone-dragover",
        onDropFiles: null
    },

    targetEl: null,
    dragging: false,

    initialize: function (options) {
        this.setOptions(options);

        if (!this.options.target)
            throw "No target specified for drop zone";

        this.targetEl = $(this.options.target);
        this.targetEl.addClass(this.options.targetClass);
        this.targetEl.addEvents({
            "dragenter": this.onDragOver,
            "dragover": this.onDragOver,
            "dragleave": this.onDragLeave,
            "drop": this.onDrop
        });
    },

    onDragOver: function (e) {
        if (e.preventDefault) {
            e.preventDefault();
        }

        var evt = e.event;
        if (!evt || !evt.dataTransfer)
            return;

        if (this.hasFiles(evt)) {
            evt.dataTransfer.dropEffect = "copy";

            this.startDrag();
        }
    },

    onDragLeave: function (e) {
        if (e.preventDefault) {
            e.preventDefault();
        }

        this.stopDrag();
    },

    onDrop: function (e) {
        if (e.preventDefault) {
            e.preventDefault();
        }

        this.stopDrag();

        var evt = e.event;
        if (!evt || !evt.dataTransfer)
            return;

        var files = evt.dataTransfer.files;

        if (typeof this.options.onDropFiles == "function")
            this.options.onDropFiles(files);
    },

    startDrag: function () {
        this.targetEl.addClass(this.options.dragClass);

        if (!this.dragging) {
            this.dragging = true;
            //this.trigger("startdragfile");
        }
    },

    stopDrag: function () {
        this.targetEl.removeClass(this.options.dragClass);

        if (this.dragging) {
            this.dragging = false;
            //this.trigger("stopdragfile");
        }
    },

    hasFiles: function (evt) {
        var typesArray = Object.values(evt.dataTransfer.types);
        return typesArray.indexOf("Files") !== -1;
    }
});